export default {
  TripOriginDestinationDetail__TO: "to",
};
